// src/components/celebrate/SpinningStar.js
//
// A big gold star that spins in with sparkles — shown on "You've earned your
// Video / Music / Sing-along Star!".
//
//   <SpinningStar size={120} />

import React from "react";
import "./celebrate.css";

const STAR = "M50 6 L61.8 36.6 L94.6 38.2 L69 59 L77.6 90.8 L50 72.8 L22.4 90.8 L31 59 L5.4 38.2 L38.2 36.6 Z";

const SpinningStar = ({ size = 120 }) => (
  <span className="sbl-star-wrap" style={{ width: size, height: size }} aria-hidden="true">
    <span className="sbl-star-rays" />
    <svg viewBox="0 0 100 100" className="sbl-star-spin">
      <defs>
        <linearGradient id="sbl-star-gold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#fff6b0" />
          <stop offset="0.45" stopColor="#ffd23f" />
          <stop offset="1" stopColor="#f0a500" />
        </linearGradient>
      </defs>
      <path d={STAR} fill="url(#sbl-star-gold)" stroke="#b07a00" strokeWidth="3" strokeLinejoin="round" />
      <path d="M50 18 L57 37 L50 33 Z" fill="#fff" opacity="0.7" />
      <circle cx="41" cy="52" r="3.4" fill="#5a3a00" />
      <circle cx="59" cy="52" r="3.4" fill="#5a3a00" />
      <circle cx="42" cy="51" r="1.1" fill="#fff" />
      <circle cx="60" cy="51" r="1.1" fill="#fff" />
      <path d="M43 61 Q50 67 57 61" stroke="#5a3a00" strokeWidth="2.6" fill="none" strokeLinecap="round" />
    </svg>
    {[0, 1, 2, 3, 4, 5].map((i) => (
      <i key={i} className="sbl-star-spark" style={{ "--a": `${i * 60}deg`, animationDelay: `${0.5 + i * 0.12}s` }} />
    ))}
  </span>
);

export default SpinningStar;
